import NavbarNotAuth from './components/navbarNotAuth'
import DivBottom from './components/divBottom'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import Luoghi from './components/luoghiImperdibili'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

function Newsletter() {
    const navigate = useNavigate()
    const [letters, setLetters] = useState([])
    function aggiungiScheda() {
        const rt = document.getElementById('aggiungiScheda').style
        if (rt.display === 'none') {
            rt.display = 'block'
            setTimeout(() => { rt.transform = "scale(1)" }, 50)
        } else {
            rt.display = 'none'; rt.transform = 'scale(.5)'
        }
        setTimeout(() => { rt.transform = "scale(1)" }, 100)
    }
    async function getNews() {
        const res = await axios.get('/getNewsletter')
        setLetters(res.data)
    }
    useEffect(() => {

        setTimeout(() => {
            getNews()
            document.getElementById('titolo').style.transform = "scale(1)"
        }, 100)
    }, [])

    return (
        <>
            {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
                : <NavbarNotAuth />}
            <div className='container-fluid' style={{ marginTop: '5rem' }}>
                <p>\<b>Food&Travel</b></p>
            </div>
            <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/markus-winkler-5IWIKQ4VoX8-unsplash.webp`} className="addImg"
                style={{ margin: '2em auto' }} width={'90%'} height={'500px'} alt='' />

            <h3 className='text-center mt-5'>APPROFONDIMENTO</h3>
            <h4 id="titolo" style={{ padding: '7px', textAlign: 'center', marginTop: '1em', transition: 'transform .5s', transform: 'scale(.5)' }}>
                Ricette senza Passaporto: L'autenticità italiana non conosce distanze. Sapori e meraviglie del <i>patrimonio Italia</i>
            </h4>

            <div className='text-center'>
                <button className='btn btn-primary mt-2' onClick={aggiungiScheda}>Aggiungi scheda</button>
                <p className='border p-1' style={{ width: 'fit-content', margin: '10px auto', display: 'none', transition: 'transform .5s', transform: 'scale(.5)' }} id='aggiungiScheda'>
                    Invia una email a <i>zonaeventiinfo@gmail.com</i> con foto e contenuti testuali
                </p>
            </div>
            <div className='homePadding mt-5'>
                <div className='row' style={{ marginTop: '-2rem', cursor: 'pointer' }}>
                    {letters.reverse().map(elem => (
                        <div className="card mt-3" style={{ width: '26rem', margin: '0 auto', padding: '0px', border: '1px solid grey' }} key={elem.id}
                            onClick={() => { navigate('/newsletterDetails', { state: elem }) }}>
                            {/* <Link to={{ pathname: `/newsletterDetails/${elem.id}` }} style={{ textDecoration: 'none', color: 'black' }}> */}
                            <img src={`https://leuro-bucket.s3.amazonaws.com/newsletter/${elem.img.split(',')[0]}`} className="card-img-top homeImage" alt='' />
                            <div className="card-body">
                                <h5 className="card-title"><b>{elem.cardtitle}</b></h5>
                                <p className="card-text">{elem.cardtext}</p>
                                <button className="btn btn-primary">Scopri di più
                                </button>
                                <span style={{ fontSize: 'small', float: 'right', color: 'navy', fontWeight: '600' }}>{elem.created_at}</span>
                            </div>
                            {/* </Link> */}
                        </div>
                    ))}
                </div>
            </div>
            <Luoghi />
            <DivBottom />
        </>
    )
}
export default Newsletter